import React, { useState } from 'react';
import { createQuest, testQuestStatus, markQuestComplete } from './scripts';

export default function QuestManager() {
  // Tab state
  const [activeTab, setActiveTab] = useState('create');

  // For Create Quest
  const [createQuestName, setCreateQuestName] = useState('');
  const [createRequired, setCreateRequired] = useState(false);
  const [createPoints, setCreatePoints] = useState(0);
  const [createResult, setCreateResult] = useState(null);
  const [createError, setCreateError] = useState(null);

  // For Status
  const [statusQuestName, setStatusQuestName] = useState('');
  const [statusAddress, setStatusAddress] = useState('');
  const [statusResult, setStatusResult] = useState(null);
  const [statusError, setStatusError] = useState(null);

  // For Complete
  const [completeQuestName, setCompleteQuestName] = useState('');
  const [completeAddress, setCompleteAddress] = useState('');
  const [completePassportId, setCompletePassportId] = useState('');
  const [completeResult, setCompleteResult] = useState(null);
  const [completeError, setCompleteError] = useState(null);

  const handleCreate = async () => {
    setCreateError(null);
    setCreateResult(null);
    try {
      const res = await createQuest(createQuestName, createRequired, createPoints);
      setCreateResult(res);
    } catch (e) {
      setCreateError(e.message);
    }
  };

  const handleStatus = async () => {
    setStatusError(null);
    setStatusResult(null);
    try {
      const res = await testQuestStatus(statusQuestName, statusAddress);
      setStatusResult(res);
    } catch (e) {
      setStatusError(e.message);
    }
  };

  const handleComplete = async () => {
    setCompleteError(null);
    setCompleteResult(null);
    try {
      const res = await markQuestComplete(completeQuestName, completeAddress, completePassportId || null);
      setCompleteResult(res);
    } catch (e) {
      setCompleteError(e.message);
    }
  };

  return (
    <div className="mt-10">
      {/* Tabs */}
      <div className="form-card">

        <div className="flex gap-4  form-tabs">
          <button
            className={`btn ${activeTab === 'create' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setActiveTab('create')}
          >
            Create Quest
          </button>
          <button
            className={`btn ${activeTab === 'status' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setActiveTab('status')}
          >
            Test Quest Status
          </button>
          <button
            className={`btn ${activeTab === 'complete' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setActiveTab('complete')}
          >
            Mark Quest Complete
          </button>
        </div>
        {/* Tab Content */}
        {activeTab === 'create' && (
          <div className="create">
            <div className="mb-2">
              <label>Quest Name</label>
              <input className="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm"
                value={createQuestName} onChange={e => setCreateQuestName(e.target.value)} />
            </div>
            <div className="flex flex-col justify-start mb-4">
              <label>Required</label>
              <div>
                <input type="checkbox" checked={createRequired} onChange={e => setCreateRequired(e.target.checked)} />
              </div>
            </div>
            <div className="mb-2">
              <label>Points: </label>
              <input className="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm" type="number" value={createPoints} onChange={e => setCreatePoints(Number(e.target.value))} />
            </div>
            <div className="flex justify-end">
              <button className="btn btn-primary text-lg px-6 py-2 " onClick={handleCreate}>Create Quest</button>
            </div>
            {createResult && <pre className="mt-8 bg-gray-100 p-2 rounded text-sm border-2 border-dashed">{JSON.stringify(createResult, null, 2)}</pre>}
            {createError && <div className="text-red-600 mt-2">{createError}</div>}
          </div>
        )}
        {activeTab === 'status' && (
          <div className="status">
            <div className="mb-2">
              <label>Quest Name</label>
              <input className="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm"
                value={statusQuestName} onChange={e => setStatusQuestName(e.target.value)} />
            </div>
            <div className="mb-2">
              <label>Wallet Address:</label>
              <input className="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm" value={statusAddress} onChange={e => setStatusAddress(e.target.value)} />
            </div>
            <div className="flex justify-end">
              <button className="btn btn-primary text-lg px-6 py-2" onClick={handleStatus}>Check Status</button>
            </div>
            {statusResult && <pre className="mt-8 bg-gray-100 p-2 rounded text-sm border-2 border-dashed">{JSON.stringify(statusResult, null, 2)}</pre>}
            {statusError && <div className="text-red-600 mt-2">{statusError}</div>}
          </div>
        )}
        {activeTab === 'complete' && (
          <div className="complete">
            <div className="mb-2">
              <label>Quest Name</label>
              <input className="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm"
                value={completeQuestName} onChange={e => setCompleteQuestName(e.target.value)} />
            </div>
            <div className="mb-2">
              <label>Wallet Address:</label>
              <input className="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm" value={completeAddress} onChange={e => setCompleteAddress(e.target.value)} />
            </div>
            <div className="mb-2">
              <label>Passport ID:</label>
              <input className="w-full p-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm" value={completePassportId} onChange={e => setCompletePassportId(e.target.value)} />
            </div>
            <div className="flex justify-end">
              <button className="btn btn-primary text-lg px-6 py-2" onClick={handleComplete} >Mark Complete</button>
            </div>
            {completeResult && <pre className="mt-8 bg-gray-100 p-2 rounded text-sm border-2 border-dashed">{JSON.stringify(completeResult, null, 2)}</pre>}
            {completeError && <div className="text-red-600 mt-2">{completeError}</div>}
          </div>
        )}
      </div>

    </div>
  );
}
